<!-- 世界杯赞助商 -->
<template>
<div class="sponser" v-if="pageLoading" v-loading="postLoading">
    <div class="cont-row title-row">
        <div class="main-title">世界杯赞助商</div>
        <div class="pull">点击领取游戏币</div>
        <div class="flex-cont"></div>
        <div class="rule" @click="pullRulesStatus = true">领取规则&gt;</div>
    </div>
    <swiper :options="swiperOptions">
        <swiper-slide v-for="(item,index) in list" :key="index">
            <ul class="grow-container" >
                <li v-for="(subitem,indent) in item" :key="indent" @click="robCurrency(subitem)">
                    <div class="white-border">
                        <div class="box">
                            <img :src="subitem.image1" alt="">
                        </div>
                        <div class="tag" v-if="subitem.totalAvailable == 0"><img :src="require('../assets/rob-over.png')" alt="" height="32"></div>
                        <div class="tag" v-else-if="subitem.icanpick == 0 "><img :src="require('../assets/robed.png')" alt="" height="32"></div>
                        <div class="tag" v-else><img :src="require('../assets/rob.png')" alt=""></div>
                    </div>
                </li>
            </ul>
        </swiper-slide>
        
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <PullRules :status.sync="pullRulesStatus" />
</div>
</template>
<script>
import {hostBuild} from '@/utils/utils.js'
import PullRules from '../dialog/pull-rules.vue'
export default {
    name:'sponser',
    components:{PullRules},
    data(){
        return  {
            pageLoading:false,
            postLoading:false,
            pullRulesStatus:false,
             // 轮播图配置
            swiperOptions: {
                spaceBetween: 30,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                
            
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
            list:[],
            list1:[],
            /* list1:[
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
                'https://media3.imgyb.xyz/media/v1/image/c0f1bf0af428a77086297ecada185f1d.jpeg',
            ] */
        }
    },
    created(){
        //this.transitionData();
        this.getList();
    },
    methods:{
        transitionData(){
            var cache = [];
            for(var i=0; i<this.list1.length; i++){
                
                let indent = Math.floor(i/4);
                if(!cache[indent]){
                    cache[indent] = []
                }
                cache[indent].push(this.list1[i]);
                console.log(indent)
            }
            this.list = cache;
        },
        async getList(){
            let result = await this.$axios.get('/worldcup2022/admin/sponsor/list')
            if( result.code == 0 ){
                console.log('赞助商列表-====》',result);
                this.list1 = result.data.sponsors;
                this.transitionData();
                this.pageLoading = true;
                console.log(this.list)
            }
        },
        //抢游戏币
        async robCurrency(data){
            console.log(data);
            this.postLoading = true;
            let result = await this.$axios.post('/worldcup2022/game/coin/pick/from/sponsor',{sponsorId:data.id}).finally(()=>{

                this.postLoading = false;
            });
            if(result.code == 0 ){
                console.log( result.data.amount);
                data.icanpick = 0;
                this.$success(`恭喜抢到${result.data.amount}个游戏币`);
                this.$emit('success');
            }else if( result.code == 1 ){
                this.$confirm('需要登录才能领取', '提示', {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let path ='/login?redirect=' + encodeURIComponent(window.location.href);
                    window.location.href = hostBuild(path,'account');
                }).catch(() => {
                            
                });
            }
        }
    }
}
</script>
<style lang="less" scoped>
.sponser{
    background: url('../assets/top-bg.png') no-repeat right top #F54A48; padding: 20px 15px ; border-radius: 10px; margin-bottom: 20px;
    .title-row{
        margin-bottom: 25px;
        .main-title{font-size: 20px; line-height: 28px; color: #fff; margin-right: 10px; font-weight: 500;}
        .pull{font-size: 18px; line-height: 24px; color: #fff; }
        .rule{font-size: 16px; line-height: 20px; color: #fff; opacity: 0.7; text-decoration: underline; cursor: pointer;}
    }
}
/deep/.swiper-container{
    padding-bottom: 46px;
    .swiper-wrapper{
        .swiper-slide{
            .grow-container{
                margin:0 -8px; display: flex; flex-wrap: wrap;
                li{
                    padding: 0 8px; width: 25%; box-sizing: border-box;
                    .white-border{
                        border: 10px solid #fff; border-radius: 10px;background: #fff; position: relative; cursor: pointer;
                        .tag{position: absolute; right:-1px; bottom: 0;}
                    }
                    .box{
                        position: relative; font-size: 0; border-radius: 10px; overflow: hidden;
                        &:after{ content: ''; display: inline-block; padding-bottom: 75%;}
                        img{position:absolute; left: 0; top: 0; width: 100%; height: 100%; object-fit: cover; transition: all 200ms linear;}
                        &:hover{
                            img{transform: scale(1.2);}
                        }
                    }
                }
            }
        }   
    }
    .swiper-pagination{bottom: 5px;
        .swiper-pagination-bullet{background: #fff ; opacity: 0.4;}
        .swiper-pagination-bullet-active{opacity: 1;}
    }
    .swiper-button-next, .swiper-button-prev{color: #fff;}
}
@media screen and (max-width:768px){
    .sponser{
        padding: 10px 7px ; margin-bottom: 10px;
        .title-row{
            margin-bottom: 25px;
            .main-title{display: none;}
        }
    }
    /deep/.swiper-container{
        padding-bottom: 15px;
        .swiper-wrapper{
            .swiper-slide{
                .grow-container{
                    margin:0 -8px; display: flex; flex-wrap: wrap;
                    li{ width:50%; margin-bottom: 16px;
                        .white-border{border-width: 5px;}
                    }
                }
            }
        }
    }
}
</style>